import { BaseMapper } from '@ps/utils';
import {
  SurveyLocationUploadResult,
  SurveyQualificationCondition,
} from '@ps/survey-utils';

import { ZipcodeUploadResponseDto } from '../dtos/location-upload.dto';

// A zip has no label of its own, so it is both the code and the name.
const _condition = (zipcode: string): SurveyQualificationCondition => ({
  id: zipcode,
  name: zipcode,
});

export class ZipcodeUploadMapper extends BaseMapper<
  ZipcodeUploadResponseDto,
  SurveyLocationUploadResult
> {
  public fromDto(dto: ZipcodeUploadResponseDto): SurveyLocationUploadResult {
    const summary = dto.zipcodes;

    return {
      validCodes: summary.validZipcodes.map(_condition),
      totalCodeCount: summary.totalZipcodes,
      correctCodeCount: summary.correctZipcodes,
      duplicateCodeCount: summary.duplicateZipcodes,
      incorrectCodeCount: summary.incorrectZipcodes,
      incorrectCodes: summary.incorrectZipCodesList ?? [],
      modifiedCodeCount: summary.modifiedZipcodes,
      filePath: dto.zipcodeFilePath,
      groupedCodes: summary.groupedZipCodes,
    };
  }
}
